import React from 'react';
import { Field, TextArea, EstadoRow, Callout } from '../product_config/formkit';
import {
  CALCULATOR_TYPES,
  LABEL_CALCULADORA,
  matrizCrossSell,
  flujosDondeSeSugiere,
  sugeridosEnFlujo,
} from '../../lib/crossSellRequisitos';

export default function SugerenciasTab({ jsonConfig, handleJsonConfigChange }) {
  const participa = jsonConfig?.sugerencia?.participa !== false;
  const nota = jsonConfig?.sugerencia?.nota || '';
  const tipo = jsonConfig?.calculatorConfig?.type || '';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 22 }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600, color: '#1A1A1A' }}>
          Participación en cross-sell
        </h3>
        <EstadoRow
          titulo="Sugerir este plan en otros flujos"
          texto="Si lo desactivas, este plan nunca aparece como sugerido, aunque técnicamente se pueda cotizar."
          on={participa}
          onChange={(v) => handleJsonConfigChange('sugerencia.participa', v)}
        />
        {!participa && (
          <Field label="Motivo (opcional)" full>
            <TextArea
              value={nota}
              placeholder="Ej: no comercializamos este plan como cross-sell."
              onChange={(e) => handleJsonConfigChange('sugerencia.nota', e.target.value)}
            />
          </Field>
        )}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600, color: '#1A1A1A' }}>
          Dónde se sugiere (derivado de la calculadora)
        </h3>
        <Callout tone="info" title="Regla automática">
          La compatibilidad se deriva de la calculadora del plan y los datos que exige.
          Esta matriz es de referencia; no se edita aquí.
        </Callout>
        {tipo ? (
          <>
            <p style={{ margin: 0, fontSize: 13, color: '#54585A' }}>
              Este plan usa <strong>{LABEL_CALCULADORA[tipo] || tipo}</strong> y se sugerirá en flujos:{' '}
              <strong>
                {flujosDondeSeSugiere(tipo).map((t) => LABEL_CALCULADORA[t] || t).join(', ') || '—'}
              </strong>.
            </p>
            <p style={{ margin: 0, fontSize: 13, color: '#54585A' }}>
              En un flujo de este plan se pueden sugerir:{' '}
              <strong>
                {sugeridosEnFlujo(tipo).map((t) => LABEL_CALCULADORA[t] || t).join(', ') || '—'}
              </strong>.
            </p>
          </>
        ) : (
          <Callout tone="warn">
            Configura primero la calculadora en el tab "Calculator config".
          </Callout>
        )}
        <details>
          <summary style={{ cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#54585A' }}>
            Matriz completa (referencia)
          </summary>
          <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <MatrizGrid highlight={tipo} />
            <p style={{ margin: 0, fontSize: 11, color: '#8D8D8D' }}>
              Entre planes de la misma calculadora por atributos, la compatibilidad real
              depende de que compartan la misma clave de atributo (ej. especialidad).
            </p>
          </div>
        </details>
      </div>
    </div>
  );
}

function MatrizGrid({ highlight }) {
  const filas = matrizCrossSell();
  const cell = { padding: '6px 8px', fontSize: 12, textAlign: 'center', borderBottom: '1px solid #EEE' };
  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ borderCollapse: 'collapse', minWidth: 560 }}>
        <thead>
          <tr>
            <th style={{ ...cell, textAlign: 'left', fontWeight: 600 }}>Flujo ↓ / Sugerido →</th>
            {CALCULATOR_TYPES.map((t) => (
              <th key={t} style={{ ...cell, fontWeight: 600 }}>{LABEL_CALCULADORA[t] || t}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filas.map((fila) => (
            <tr key={fila.origen} style={fila.origen === highlight ? { background: '#F3FBF8' } : undefined}>
              <td style={{ ...cell, textAlign: 'left', fontWeight: 600 }}>
                {LABEL_CALCULADORA[fila.origen] || fila.origen}
              </td>
              {fila.celdas.map((c) => (
                <td
                  key={c.destino}
                  style={{ ...cell, color: c.compatible ? '#158B5C' : '#C0C0C0', fontWeight: c.compatible ? 700 : 400 }}
                >
                  {c.compatible ? '✓' : '·'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
